import React from "react";
import { Box, Typography, Button, Container, styled } from "@mui/material";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// --- Styled Components (Professional Const Style) ---

const CTASection = styled(Box)(({ theme }) => ({
    width: "100%",
    padding: theme.spacing(12, 0),
    position: "relative",
    background: `
        linear-gradient(
            rgba(9, 18, 44, 0.65), 
            rgba(9, 18, 44, 0.75)
        ),
        url("https://images.unsplash.com/photo-1497366754035-f200968a6e72?q=80&w=2069&auto=format&fit=crop")
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundAttachment: "fixed", // Parallax depth
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
}));

const GlassCard = styled(Box)(({ theme }) => ({
    backgroundColor: "rgba(255, 255, 255, 0.95)", // High contrast white
    backdropFilter: "blur(12px)", // Soft frosted effect
    padding: theme.spacing(6),
    borderRadius: "16px",
    boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // Ensures "fit-size" button stays centered
    borderTop: "6px solid #B8860B", // Professional goldenrod accent bar
}));

const CardTitle = styled(Typography)(({ theme }) => ({
    color: "#09122C",
    fontWeight: 800,
    fontSize: "2.4rem",
    letterSpacing: "-0.02em",
    lineHeight: 1.2,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
        fontSize: "1.8rem",
    },
}));

const CardSubtitle = styled(Typography)(({ theme }) => ({
    color: "#333",
    fontSize: "1.1rem",
    lineHeight: 1.7,
    maxWidth: "500px",
    marginBottom: theme.spacing(4),
}));

const StyledButton = styled(Button)(({ theme }) => ({
    width: "fit-content", // Key change for size
    backgroundColor: "#09122C",
    color: "#FFFFFF",
    fontWeight: 700,
    textTransform: "none",
    padding: "14px 40px",
    fontSize: "1rem",
    borderRadius: "50px", // Pill shape for modern action
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:hover": {
        backgroundColor: "#1a2a5a",
        transform: "translateY(-3px)",
        boxShadow: "0 8px 20px rgba(9, 18, 44, 0.3)",
    },
}));

// --- Main Component ---

export default function EnrollmentSection() {
    return (
        <CTASection>
            <Container maxWidth="sm">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                >
                    <GlassCard>
                        {/* Status Badge */}
                        <Typography
                            sx={{
                                color: "#B8860B",
                                fontWeight: 800,
                                fontSize: "0.75rem",
                                letterSpacing: 2,
                                mb: 1.5,
                                textTransform: "uppercase"
                            }}
                        >
                            Next Intake Starting Soon
                        </Typography>

                        <CardTitle variant="h4">
                            Ready to Start Your Career?
                        </CardTitle>

                        <CardSubtitle>
                            Join thousands of students who are transforming their futures with
                            world-class training and dedicated career support.
                        </CardSubtitle>

                        {/* Fit-size CTA */}
                        <Link to="/login" style={{ textDecoration: "none" }}>
                            <StyledButton variant="contained" disableElevation>
                                Get Started Now
                            </StyledButton>
                        </Link>

                        <Typography
                            sx={{
                                mt: 3,
                                fontSize: "0.85rem",
                                color: "#666",
                                fontWeight: 500,
                                fontStyle: "italic"
                            }}
                        >
                            Secure your admission today.
                        </Typography>
                    </GlassCard>
                </motion.div>
            </Container>
        </CTASection>
    );
}
